if (!customElements.get('hy-diagram-connectors')) {
  customElements.define('hy-diagram-connectors', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.pu55-diagram');
      this.body = this.section.querySelector('.pu55-diagram__body');
      this.stage = this.section.querySelector('.pu55-diagram__stage');
      this.svg = this.section.querySelector('.pu55-diagram__linked-lines');
      this.image = this.section.querySelector('.pu55-diagram__product img');
      this.features = [...this.section.querySelectorAll('.pu55-diagram__feature')];
      this.dots = [...this.section.querySelectorAll('.pu55-diagram__dot')];
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.draw());
      };
      this.media = matchMedia('(max-width: 900px)');
      this.media.addEventListener('change', this.schedule);
      this.observer = new ResizeObserver(this.schedule);
      [this.stage, this.image, ...this.features].forEach(node => this.observer.observe(node));
      this.image.addEventListener('load', this.schedule);
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.schedule);
      this.image?.removeEventListener('load', this.schedule);
    }

    draw() {
      if (!this.media.matches || this.body.dataset.mobile !== 'overlay') return;
      const stage = this.stage.getBoundingClientRect();
      if (!stage.width || !stage.height) return;
      const product = this.image.getBoundingClientRect();
      const paths = [...this.svg.querySelectorAll('path')];
      const anchors = [...this.svg.querySelectorAll('circle')];
      this.svg.setAttribute('viewBox', `0 0 ${stage.width} ${stage.height}`);

      this.features.forEach((feature, index) => {
        const dot = this.dots[index]?.getBoundingClientRect();
        const pill = feature.querySelector('.pu55-diagram__pill');
        if (!dot || !pill || !paths[index]) return;
        const rect = feature.getBoundingClientRect();
        const label = pill.getBoundingClientRect();
        const x = label.left + label.width / 2 - stage.left;
        const y = (index === 2 ? label.top : rect.bottom + 6) - stage.top;
        const dx = dot.left + dot.width / 2 - stage.left;
        const dy = dot.top + dot.height / 2 - stage.top;
        const radius = dot.width / 2;
        let path;

        if (index === 0) {
          const corridor = Math.max(12, product.left - stage.left - 16);
          path = `M ${x} ${y} V ${y + 14} H ${corridor} V ${dy} H ${dx - radius}`;
        } else if (index === 2) {
          const corridor = Math.min(stage.width - 12, product.right - stage.left + 18);
          path = `M ${x} ${y} V ${y - 16} H ${corridor} V ${dy} H ${dx + radius}`;
        } else {
          path = `M ${x} ${y} V ${y + 14} H ${dx} V ${dy - radius}`;
        }
        paths[index].setAttribute('d', path);
        anchors[index].setAttribute('cx', x);
        anchors[index].setAttribute('cy', y);
      });
      this.body.dataset.linked = '';
    }
  });
}
